module.exports = __webpack_public_path__ + "img/drivehorizon.008ee0cb.webp";